import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, className }) => {
  return (
    <label for={attributes.fieldId} className='Input-label'>
      <input type="checkbox" className="Checkbox" id={attributes.fieldId} />
      <span className='Checkbox-text'>{attributes.text}</span>
    </label>
  )
}
